import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import Box from '@mui/material/Box';

import { ErrorContentProps } from './ErrorContent';
import { RedirectCounter } from './RedirectCounter';

export const ErrorDetails = ({
	children,
	title,
	subtitle,
	description,
}: ErrorContentProps) => {
	return (
		<Box
			sx={{
				display: 'flex',
				justifyContent: 'center',
				textAlign: 'center',
				pt: 3,
			}}>
			<div className="alert alert-danger" role="alert">
				<ReportProblemIcon fontSize="large" />
				<h2 className="alert-heading">{title}</h2>
				<p>{subtitle}</p>
				{description && (
					<>
						<hr />
						<p className="mb-0">{description}</p>
					</>
				)}
				{children}
				<RedirectCounter />
			</div>
		</Box>
	);
};
